module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-footer",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_CommonFooter"
    }
  }, [_c('footer', [_c('div', {
    staticClass: "footer-container"
  }, [_c('ul', {
    staticClass: "footer-info"
  }, [_c('li', {
    attrs: {
      "id": "J_CopyRight"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;",
      "id": "J_LawLink"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd13f96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 130
// module chunks = 1